var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"space-root h-100"},[(_vm.isLoading)?_c('b-spinner',{staticClass:"d-block mx-auto text-primary my-2"}):_c(("layout-" + _vm.layout),{tag:"component",on:{"error":_vm.handleLayoutError}},[_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }